import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: 'pgQGFg',
    defaultMessage: "Kit members",
    description: "kit detail, card title",
  },
  addMember: {
    id: 'FngRgt',
    defaultMessage: "Add member",
    description: "kit detail, button",
  },
  removeMember: {
    id: 'xZ43Vi',
    defaultMessage: "Remove member",
    description: "kit detail, row menu",
  },
  noMembers: {
    id: 'tfk6tN',
    defaultMessage: "No members yet. Add the products this kit is sold as.",
    description: "kit detail, empty members table",
  },
  product: {
    id: 'yEGQoH',
    defaultMessage: "Product",
    description: "kit members table column",
  },
  label: {
    id: 'epLJWV',
    defaultMessage: "Label",
    description: "kit members table column, the member's short name on the kit page",
  },
  quantity: {
    id: '6GrGYv',
    defaultMessage: "Quantity",
    description: "kit members table column",
  },
});
